module.exports = __webpack_public_path__ + "img/svg/background-wallet.f91541ed3dd23e09979c0428ea374766.svg";